import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import './App.css';

// Page imports
import Login from './pages/Login/Login';
import RoleBasedHome from './components/RoleBasedRedirect/RoleBasedHome';
import TenantHome from './pages/Tenant/TenantHome';
import LandlordHome from './pages/Landlord/LandlordHome';
import Tenancy from './pages/Shared/Tenancy';
import AI from './pages/Shared/AI';
import Messages from './pages/Shared/Messages';
import TenantInfo from './pages/Shared/TenantInfo';
import LandlordInfo from './pages/Shared/LandlordInfo';
import Settings from './pages/Shared/Settings';

import ProtectedRoute from './components/ProtectedRoute';

function App() {

  return (
    <Router>
      <Routes>
        {/* Login Page */}
        <Route path="/login" element={<Login />} />

        {/* Redirect to Login, TenantHome or LandlordHome Page depending on permissions */}
        <Route index element={<RoleBasedHome />} />



        {/* Shared Layout */}
        <Route path="/" element={ <ProtectedRoute allowedRoles={['tenant', 'landlord']}> <Layout /> </ProtectedRoute> } >
          {/* Tenant Homepage */}
          <Route path="tenant" element={<ProtectedRoute allowedRoles={['tenant']}> <TenantHome /> </ProtectedRoute>} />
          {/* Landlord Homepage */}
          <Route path="landlord" element={<ProtectedRoute allowedRoles={['landlord']}> <LandlordHome /> </ProtectedRoute>} />
          {/* Shared pages */}
          <Route path="tenancy" element={<Tenancy />} />
          <Route path="ai" element={<AI />} />
          <Route path="messages" element={<Messages />} />
          <Route path="tenant-info" element={<TenantInfo />} />
          <Route path="landlord-info" element={<LandlordInfo />} />
          <Route path="settings" element={<Settings />} />
          {/* Optional: 404 page */}
          <Route path="*" element={<div>Page Not Found</div>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
